jQuery(function () {
(function () {
    "use strict";

    var Accordion = function (el, options) {
        this.settings = options;
        this.$el = $(el);
        this.$items = this.$el.find("> .accordion-item, > span > .accordion-item");
        this.$titles = this.$items.find("> .accordion-title");

        this.shouldSetMaxHeight = this.$el.closest(".align-height").length;
        this.prependArrow = this.$el.hasClass("accordion-prepend-arrow");
        this.keepItemsOpen = this.$el.hasClass("accordion-keep-open");

        this.init();
    };

    Accordion.prototype = {
        init: function () {
            var self = this;

            self.$items.each(function () {
                var $item = $(this);
                var $content = $item.find("> .accordion-content");
                var $inner = $content.find("> .accordion-content-inner");

                if (!$item.hasClass("accordion-expanded")) {
                    $item.addClass("accordion-collapsed");
                    $content.css({
                        height: 0,
                        opacity: 0,
                        overflow: "hidden"
                    });
                    $inner.css({
                        height: 0,
                        overflow: "hidden"
                    });
                    $item.attr("aria-expanded", "false");
                    $inner.removeAttr("tabindex");
                } else {
                    $content.css({
                        height: "auto",
                        opacity: 1,
                        overflow: "visible"
                    });
                    $inner.css({
                        height: "auto",
                        overflow: "visible"
                    });
                    $item.attr("aria-expanded", "true");
                    $inner.attr("tabindex", "0");
                }
            });

            // Add icons
            self.$titles.each(function () {
                var $icon = $(this).find("i"),
                    arrow = '<i class="icon-arrow-down"></i>';

                if (!$icon.length && !self.$el.hasClass("accordion-no-icon")) {
                    if (self.prependArrow) {
                        $(this)
                            .wrapInner('<span class="accordion-title-content"></span>')
                            .prepend(arrow);
                    } else {
                        $(this).prepend(arrow);
                    }
                }
            });

            self.bindEvents();

            if (self.shouldSetMaxHeight) {
                self.$el.addClass("dynamic-height");
                $(window).on("resize", function () {
                    self.setMaxHeight();
                });
                self.setMaxHeight();
            }
        },

        bindEvents: function () {
            var self = this;

            self.$el.on("click keydown",
                 "> .accordion-item > .accordion-title, > span > .accordion-item > .accordion-title",
                function (e) {
                    if (e.type === "keydown" && (e.key !== "Enter" && e.key !== " " && e.key !== "Spacebar")) return;
                    var $this = $(this);
                    var $item = $this.closest(".accordion-item");

                    // For reviewDropdown, ignore ANY clicks that originated inside .accordion-content
                    if (
                        $item.attr("id") === "reviewDropdown" &&
                        $(e.target).closest(".accordion-content").length
                    ) {
                        return; // PowerReviews clicks inside content are ignored
                    }
                    e.preventDefault();

                    if ($item.hasClass("accordion-inactive")) return;

                    if ($item.hasClass("accordion-expanded")) {
                        self.contract($item);
                    } else {
                        self.expand($item);
                    }

                    // Set aria-expanded=false for all other items
                    self.$items.not($item).attr("aria-expanded", "false");

                    var expanded = $this.attr("aria-expanded") === "true";
                    $this.attr("aria-expanded", !expanded);
                }
            );
        },

        expand: function ($item) {
            var self = this;
            var $content = $item.find("> .accordion-content");
            var $inner = $content.find("> .accordion-content-inner");
            var $icon = $item.find("> .accordion-title i");

            if (!self.keepItemsOpen) {
                self.$items.filter(".accordion-expanded").each(function () {
                    self.contract($(this));
                });
            }

            var innerHeight = $inner.outerHeight(true);

            $inner.css({
                height: innerHeight,
                overflow: "hidden"
            });

            $content
                .css({
                    height: 0,
                    opacity: 0,
                    overflow: "hidden"
                })
                .animate({
                    height: innerHeight,
                    opacity: 1
                }, 300, function () {
                    $content.css({
                        height: "auto",
                        overflow: "visible"
                    });
                    $inner.css({
                        height: "auto",
                        overflow: "visible"
                    });
                });

            $item
                .removeClass("accordion-collapsed")
                .addClass("accordion-expanded");

            $icon.removeClass("icon-arrow-down").addClass("icon-arrow-up");
            $inner.attr("tabindex", "0");

            $.event.trigger("accordion.changed", {
                show: $item
            });
        },

        contract: function ($item) {
            var $content = $item.find("> .accordion-content");
            var $inner = $content.find("> .accordion-content-inner");
            var $icon = $item.find("> .accordion-title i");

            var currentHeight = $inner.outerHeight(true);

            $inner.css({
                height: currentHeight,
                overflow: "hidden"
            });

            $content
                .css({
                    height: currentHeight,
                    opacity: 1,
                    overflow: "hidden"
                })
                .animate({
                    height: 0,
                    opacity: 0
                }, 300, function () {
                    $content.css({
                        height: 0,
                        overflow: "hidden"
                    });
                    $inner.css({
                        height: 0,
                        overflow: "hidden"
                    });
                    $item.removeClass("accordion-expanded").addClass("accordion-collapsed");
                    $icon.removeClass("icon-arrow-up").addClass("icon-arrow-down");
                });
            $inner.removeAttr("tabindex");
        },

        setMaxHeight: function () {
            var maxHeight = 0;
            var self = this;
            var $currentItem = self.$items.filter(".accordion-expanded");

            $currentItem.removeClass("accordion-expanded");

            self.$items.each(function () {
                var $item = $(this);
                $item.addClass("accordion-expanded");
                if (self.$el.outerHeight(true) > maxHeight) {
                    maxHeight = self.$el.outerHeight(true);
                }
                $item.removeClass("accordion-expanded");
            });

            $currentItem.addClass("accordion-expanded");
            self.$el.attr("data-dynamic-height", maxHeight);
        }
    };

    $.fn.accordion = function (options) {
        var args = Array.prototype.slice.call(arguments, 1),
            $this,
            data;

        return this.each(function () {
            $this = $(this);
            data = $this.data("accordion");

            if (!data) {
                data = new Accordion(this, options);
                $this.data("accordion", data);
            }

            if (typeof options === "string") {
                data[options](args);
            }
        });
    };

    $.fn.accordion.Constructor = Accordion;

    // Initialize
    $(".accordion").accordion();

})(jQuery);

});